module.exports = __webpack_public_path__ + "static/media/29ADMSPC31.85cf6877.jpg";